import styled from 'styled-components'

export const LinkListWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  color: ${({ theme }) => theme.colors['sideBar.foreground']};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 16px;
    justify-content: center;
  }
`

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
  max-width: 400px;
  min-width: 300px;
  overflow-y: auto;
`

export const LinkRow = styled.a`
  display: flex;
  gap: 12px;
  /* border: 1px solid ${({ theme }) => theme.colors['sideBar.border']}; */
  /* padding: 12px; */
  border-radius: 8px;
  font-weight: 500 !important;
  text-decoration: none;
  color: ${({ theme }) => theme.colors['sideBar.foreground']};
  transition: background-color 0.2s;

  border: 1px solid ${({ theme }) => theme.colors['activityBar.inactiveForeground']};
  padding: 30px;

  &:hover {
    background-color: ${({ theme }) => theme.colors['activityBar.inactiveForeground']};
    color: ${({ theme }) => theme.colors['sideBar.foreground']};
    cursor: pointer;
  }

  &:active {
    color: ${({ theme }) => theme.colors['sideBar.foreground']};
  }

  &:focus {
    outline: none;
  }

  &:visited {
    color: ${({ theme }) => theme.colors['sideBar.foreground']};
  }
`

export const LinkTitle = styled.span`
  display: flex;
  align-items: center;
  background-color: transparent;
  color: inherit;
  text-decoration: none;
`

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  svg {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    border-radius: 4px;
  }
`

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors['sideBar.foreground']};
  margin-top: 0;
`
